<template>
  <section class="home">
    <!--头部组件-->
    <v-login-info></v-login-info>

    <div class="home-content">
      <!--开发模块开始-->
      <div class="development">
        <!--标题开始-->
        <div class="title">
          <div class="left clearfix">
            <span class="text">开发</span>
            <i class="icon icon-development"></i>
          </div>

          <div class="right clearfix" v-if="!isDevStatus">
            <a class="item more" href="http://sm.yingxiong.com/special/kun-plan.html" target="_blank">了解更多</a>

            <router-link class="item apply-developer" to="/developerAgreement" v-if="applyStatus">申请成为开发者</router-link>
            <!--<a class="item apply-developer" href="javascript: void(0)" @click="applyDevFn">申请成为开发者</a>-->

            <router-link class="apply-developer item examine" to="/developerStatus" v-if="!applyStatus">审核中</router-link>

            <!--<a class="apply-developer item examine" href="javascript: void(0)" v-if="!applyStatus">审核中</a>-->
          </div>
        </div>
        <!--标题结束-->

        <!--开发者选项列表开始-->
        <ul class="list clearfix" :class="isDevStatus ? 'active' : 'no-developer'">
          <li class="item">
            <template v-if="isDevStatus">
              <router-link class="btn" to="/downloadPlugin" :target="pcFlag">下载开发插件</router-link>
            </template>

            <template v-else>
              <a class="btn" href="javascript: void(0)">下载开发插件</a>
            </template>

          </li>

          <li class="item">
            <!--<router-link class="btn" :to="isDevStatus ? '/developmentFile' : ''">开发文档</router-link>-->
            <template v-if="isDevStatus">
              <a class="btn" href="http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3.rar">开发文档</a>
            </template>
            <template v-else>
              <a class="btn" href="javascript: void(0)">开发文档</a>
            </template>
          </li>

          <li class="item">
            <router-link class="btn" :to="isDevStatus ? '/faq' : ''">FAQ</router-link>
          </li>

          <li class="item">
            <template v-if="isDevStatus">
              <a class="btn" href="http://forumsm.yingxiong.com" :target="pcFlag">开发者论坛</a>
            </template>

            <template v-else>
              <a class="btn" href="javascript: void(0)">开发者论坛</a>
            </template>
          </li>
        </ul>
        <!--开发者选项列表结束-->

        <div class="mod-box">
          <router-link class="btn map" :class="!isDevStatus ? 'no-developer' : ''" :to="isDevStatus ? '/home/mapMod' : ''">我的地图MOD</router-link>
          <router-link class="btn server" :class="!isDevStatus ? 'no-developer' : ''" :to="isDevStatus ? '/home/selfMod' : ''">我的私服MOD</router-link>
        </div>

        <keep-alive>
          <router-view v-show="isDevStatus" :mapInfo="mapInfo"></router-view>
        </keep-alive>

        <p class="no-map-mod" v-show="!isDevStatus">
          申请成为开发者后，您将可以下载创造与魔法的开发工具包，开发您专属的MOD玩法，开发者可获得MOD服务器全部收入55%的分成~
          <!--您还没有地图MOD~，地图MOD通过《创造与魔法》开发插件制作，上传后在这里进行测试区的上线操作，玩家就可以玩到您的地图MOD了~
          <router-link class="down-plugin" to="/downloadPlugin">下载插件</router-link>-->
        </p>
      </div>
      <!--开发模块结束-->

      <!--私服开始-->
      <div class="self-server">
        <!--标题开始-->
        <div class="title">
          <div class="left">
            <span class="text">私服</span>
            <i class="icon icon-self-server"></i>
          </div>

          <div class="right clearfix" v-if="!isCreateServer">
            <!--<a class="item more" href="javascript: void(0)">了解更多</a>-->
            <router-link class="item apply-developer" to="/createServer" v-show="!isCreateServer">我要建服</router-link>
          </div>
        </div>
        <!--标题结束-->

        <!--私服列表开始-->
        <ul class="list clearfix" :class="isCreateServer ? 'active' : 'no-developer'">
          <li class="item">
            <router-link class="btn" :to="isCreateServer ? '/serverManage' : ''">私服管理</router-link>
          </li>
          <li class="item"></li>
          <li class="item"></li>
          <li class="item"></li>
        </ul>
        <!--私服列表结束-->
      </div>
      <!--私服结束-->
    </div>

    <!--使用提示层-->
    <v-basic-mask :show="tipsShow" @closeMaskEv="closeMaskEvFn">
      <div slot="desc">
        <h3 class="title">公告</h3>
        <p class="content">{{ noticeText }}</p>
      </div>    </v-basic-mask>

    <!--加载提示层-->
    <!--<v-loading :show="loadFlag"></v-loading>-->
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // loading 加载组件
  import loading from 'components/loading/loading'
  // 判断客户端来源
  import {isPc} from 'assets/js/ispc'
  // 基础弹出层组件
  import basicMask from 'components/basicMask/basicMask'
  export default {
    // 开发者首页
    name: 'home',
    data () {
      return {
        // load 标志
        // loadFlag: false,
        // 开发者地图列表
        mapInfo: '',
        // 是否是开发者
        isDeveloper: '',
        // 获取用户名
        userNmae: VueCookie.get('UserName'),
        // 错误信息
        errorTips: '',
        // 是否创建过私服
        isCreateServer: false,
        // 提示层开关
        tipsShow: false,
        // 提示信息
        tipsText: '',
        // 公告信息
        noticeText: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        }
      }
    },
    created () {
      // 初始化
      this.init()
    },
    /*
    mounted () {
      // axios 前置拦截器
      Axios.interceptors.request.use(config => {
        // 显示 loading 提示层
        this.loadFlag = true
        return config
      })
      // axios 后置拦截器
      Axios.interceptors.response.use(response => {
        // 关闭 loading 提示层
        this.loadFlag = false
        return response
      })
    },
    */
    computed: {
      isDevStatus () {
        // 是开发者
        if (this.isDeveloper >= 1) {
          return true
        // 不是开发者
        } else {
          return false
        }
      },
      // 是否申请开发者
      applyStatus () {
        switch (this.isDeveloper) {
          // 没有申请开发者
          case -1:
            return true
          // 申请开发者审核中
          case 0:
            return false
          default:
            return false
        }
      },
      // 是否是PC
      pcFlag () {
        if (isPc()) {
          return '_blank'
        } else {
          return '_self'
        }
      }
    },
    methods: {
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)

        // 是否是开发者 api
        Axios.post(`${this.$api.root}/Developer/IsDeveloper`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              // 请求成功
              case 0:
                // 获取当前开发者状态
                this.isDeveloper = res.UserType
                // 如果公开内容不为空
                if (res.Notice) {
                  // 公告信息进行赋值
                  this.noticeText = res.Notice
                  // DOM加载完毕后显示遮罩层
                  this.$nextTick(() => {
                    this.tipsShow = true
                  })
                }
                // 是开发者
                if (res.UserType === 1) {
                  // 请求开发者地图 MOD 列表
                  Axios.post(`${this.$api.root}/Developer/GetMapList`, formData, {
                    // 设置请求为表单提交
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }).then((response) => {
                    // http 请求成功
                    if (response.status === 200) {
                      // 获取接口数据
                      let res = response.data
                      switch (res.Code) {
                        case 0:
                          this.mapInfo = res.MapList
                          break
                        case 1:
                          // 删除登录信息
                          delUserCookie()
                          this.$router.push({name: 'login'})
                          break
                        default:
                          console.log(res.Msg)
                      }
                    }
                  }).catch((error) => {
                    console.log(error)
                  })
                }
                break
              // 登录信息失效，删除登录信息跳转到登录页
              case 1:
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              case 2:
                // 登录失败，将失败信息显示到界面
                this.errorTips = res.Msg
                break
              default:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页面
                this.$router.push({name: 'login'})
            }
          }
        // 请求接口失败
        }).catch((error) => {
          console.log(error)
        })

        // 请求是否创建过游戏服务器 api
        Axios.post(`${this.$api.root}/PersonalRoom/GetHaveGameServer`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                if (res.HaveGameServer) {
                  // 创建过私服
                  this.isCreateServer = true
                } else {
                  // 没有创建过私服
                  this.isCreateServer = false
                }
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 进入服务器创建页面
      createServerFn () {
        this.$router.push({name: 'createServer'})
      },
      // 进入游戏管理页面
      gameManageFn () {
        this.$router.push({name: 'serverManage'})
      },
      // 申请开发者按钮
      applyDevFn () {
        // 提示层开关
        this.tipsShow = true
          // 提示信息
        this.tipsText = '开发者后台暂未开启注册，欢迎加入鲲计划开发群参与互动讨论:546241346'
      },
      // 关闭提示层
      closeMaskEvFn (val) {
        // 关闭弹出层
        this.tipsShow = val
      }
    },
    components: {
      'v-login-info': loginInfo,
      'v-loading': loading,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "home.styl";
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue